import React, { useState, useEffect, useRef } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import useNavigateWithBase from "../hooks/useNavigateWithBase";
import axios from 'axios';
import * as XLSX from 'xlsx'; // ✅ Excel 読み込み用
import DOMPurify from 'dompurify'; // ✅ HTMLインジェクション対策
import LPPreview from "../components/LPPreview"; // ✅ LPプレビューコンポーネントをインポート
import ProgressBar from "../components/ProgressBar"; // ✅ 進捗バーをインポート
import { initialSNSData, parseSNSStrategy } from "../components/SNSParserComponent";
import SNSParserComponent from "../components/SNSParserComponent"; // ✅ パスを確認
import "../CSS/SnsStrategyPage.css";

const SnsStrategyPage = () => {
    const navigate = useNavigateWithBase();
    const { projectId } = useParams(); // 🔥 URLから `projectId` を取得
    const [companyCode] = useState(localStorage.getItem('company_code') || '');
    const [clientName] = useState('');
    const [personalName] = useState('');
    const [strategyResult, setStrategyResult] = useState(null);
    const [documentName, setDocumentName] = useState('');
    const [content, setContent] = useState('');
    const [imageUrl, setImageUrl] = useState(null); // 🔹 画像URLの状態を追加
    const [SNSimageUrl, setSNSImageUrl] = useState(null); // 🔹 SNS画像URLの状態を追加
    const [documentId, setDocumentId] = useState(null); // 🔹 ドキュメントIDを管理
    const [selectedFormats, setSelectedFormats] = useState([]);
    const [projectData, setProjectData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [strategyloading, setStrategyLoading] = useState(false);
    const [editableProject, setEditableProject] = useState({
        project_name: '',
        client_name: '',
        status: '',
        description: ''
    });
    const location = useLocation();
    const getValidValue = (input) => {
        if (typeof input === "object" && input !== null) {
            const values = Object.values(input); // オブジェクトの値を取得
            return values[0] ?? values[1] ?? ""; // 1番目の要素 > 2番目の要素 > 空文字
        }
        return input; // すでに文字列ならそのまま返す
    };
    
    // ✅ `useState` の初期値を修正
    const [companyName] = useState(() => 
        getValidValue(location.state?.companyName) || 
        getValidValue(localStorage.getItem("company_name")) || 
        ""
    );
    const [strategyData, setStrategyData] = useState({
        clientName: "",
        establishmentYear: "",
        businessDescription: "",
        mainProducts: "",
        customerValue: "",
        cost: "",
        convenience: "",
        informationChannel: "",
        differentiation: "",
        industryStandards: "",
        trustFactors: "",
        extraPrompt: "",
        additionalRequests: "",
        addRequestsLP: "",
        snsStrategy: {}
    });
    const [activeTab, setActiveTab] = useState("運用策定");

    const [fileInputKey, setFileInputKey] = useState(Date.now()); // 🔹 ファイル選択リセット用
    const [parsedData, setParsedData] = useState({
        persona: "",
        appealPoints: "",
        expression: "",
        snsStrategy: Object.create(null) // 🔥 `Object.prototype` を持たないオブジェクト
    });
    const [selectedSNS, setSelectedSNS] = useState([]);
    const [date, setDate] = useState("");
    const [theme, setTheme] = useState("");
    const [snsStrategyFiles, setSnsStrategyFiles] = useState([]);
    const [snsSelectedFile, setSnsSelectedFile] = useState("");
    const [loadedContent, setLoadedContent] = useState(""); // 選択されたファイルから読み込まれたデータ
    const [isSnsFileListLoaded, setIsSnsFileListLoaded] = useState(false); // 🔹 ファイルリストのロード状態
    const [posts, setPosts] = useState(null);
    const [loadingSNS, setLoadingSNS] = useState(false);
    const [lpHtml, setLpHtml] = useState(""); // LPのHTML
    const [loadingLP, setLoadingLP] = useState(false);
    const [savingLP, setSavingLP] = useState(false);
    const [LPStrategyFiles, setLPStrategyFiles] = useState([]);
    const [LPSelectedFile, setLPSelectedFile] = useState("");
    const [isLPFileListLoaded, setIsLPFileListLoaded] = useState(false); // 🔹 ファイルリストのロード状態
    const [uploadedImages, setUploadedImages] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0); // ✅ 進捗状態を管理
    const [lpStatus, setLpStatus] = useState(""); // ✅ status → lpStatus に変更

    // ✅ 入力値のサニタイズ（HTMLインジェクション防止）
    const sanitizeInput = (input) => {
        return DOMPurify.sanitize(input);
    };

    const fetchFiles = async () => {
        if (isSnsFileListLoaded) {
            return; // ✅ 二重リクエストを防ぐ
        }
    
        if (!projectId) {
            alert("プロジェクトIDが指定されていません");
            return;
        }
    
        try {
            const response = await axios.post("https://hmt7kejebi.execute-api.ap-northeast-3.amazonaws.com/prod/api/sns-production", {
                action: "list-files",
                projectId,
                companyName,
                documentType: "SNS戦略計画書"
            });
    
            setSnsStrategyFiles(response.data.files);
            setIsSnsFileListLoaded(true); // ✅ ロード状態を true に設定
        } catch (error) {
            console.error("ファイルリスト取得エラー:", error);
            alert("ファイルリストの取得に失敗しました");
        }
    };

    const fetchLPFiles = async () => {
        if (isLPFileListLoaded) {
            return; // ✅ 二重リクエストを防ぐ
        }
    
        if (!projectId) {
            alert("プロジェクトIDが指定されていません");
            return;
        }
    
        try {
            const response = await axios.post("https://hmt7kejebi.execute-api.ap-northeast-3.amazonaws.com/prod/api/sns-production", {
                action: "list-files",
                projectId,
                companyName,
                documentType: "SNS戦略計画書"
            });
    
            setLPStrategyFiles(response.data.files);
            setIsLPFileListLoaded(true); // ✅ ロード状態を true に設定
        } catch (error) {
            console.error("ファイルリスト取得エラー:", error);
            alert("ファイルリストの取得に失敗しました");
        }
    };
    
    // 🔹 選択されたファイルをTXTに変換し、テキストエリアに表示
    const handleFileSelect = async (fileId) => {
        try {
            if(!fileId) {
                return;
            }
            if(activeTab === "SNS投稿文書作成") {
                setSnsSelectedFile(fileId);
            } else if (activeTab === "LP案作成") {
                setLPSelectedFile(fileId);
            }
            const response = await axios.post("https://hmt7kejebi.execute-api.ap-northeast-3.amazonaws.com/prod/api/sns-production", {
                action: "convert-to-txt",
                companyName,
                fileId
            });

            const convertedContent = response.data.content;
            setLoadedContent(convertedContent); // 🔹 変換されたデータを loadedContent にセット
        } catch (error) {
            console.error("ファイル変換エラー:", error);
            setLoadedContent("ファイルの読み込みに失敗しました。");
        }
    };

    useEffect(() => {
        const sourceContent = content?.trim() !== "" ? content : loadedContent;
    
        if (!sourceContent || typeof sourceContent !== "string") {
            console.warn("⚠️ `sourceContent` が無効なため、処理をスキップ");
            return;
        }
    
        try {
            const parsed = parseContent(sourceContent);
            if (!parsed || typeof parsed !== "object") {
                console.warn("⚠️ parseContent の戻り値が不正:", parsed);
                return;
            }
    
            //console.log("📌 [DEBUG] setParsedData 適用前:", JSON.stringify(parsedData.snsStrategy, null, 2));
    
            // ✅ `parsedData.snsStrategy` と `parsed.snsStrategyRaw` を比較し、同じなら更新しない
            const isSameData = JSON.stringify(parsedData.snsStrategy) === JSON.stringify({ ...initialSNSData, ...parsed.snsStrategyRaw });
    
            if (!isSameData) {
                setParsedData(prev => ({
                    ...prev,
                    persona: parsed.persona || "",
                    appealPoints: parsed.appealPoints || "",
                    expression: parsed.expression || "",
                    snsStrategy: { ...initialSNSData, ...parsed.snsStrategyRaw }
                }));
    
                //console.log("📌 [DEBUG] `setParsedData` 更新後:", JSON.stringify(parsedData.snsStrategy, null, 2));
            }
    
            // ✅ `setSelectedSNS()` の更新
            const selected = Object.keys(parsed.snsStrategyRaw)
                .filter(platform => typeof parsed.snsStrategyRaw[platform] === "string" && parsed.snsStrategyRaw[platform].trim() !== "");
    
            setSelectedSNS(prev => {
                const prevSorted = [...prev].sort();
                const selectedSorted = [...selected].sort();
                return JSON.stringify(prevSorted) !== JSON.stringify(selectedSorted) ? selected : prev;
            });
    
        } catch (error) {
            console.error("❌ useEffect 内でエラー発生:", error);
        }
    }, [loadedContent, content]); // 🔥 `selectedSNS` を削除

    
    useEffect(() => {
    }, [imageUrl]);

    useEffect(() => {
    }, [SNSimageUrl]);

    // ✅ ファイルアップロード処理
    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) {
            alert("ファイルが選択されていません。");
            return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

                // 🔹 C列（回答欄）のデータを正しく取得
                setStrategyData({
                    clientName: sanitizeInput(jsonData[2]?.[2] || ""),
                    establishmentYear: sanitizeInput(jsonData[3]?.[2] || ""),
                    businessDescription: sanitizeInput(jsonData[4]?.[2] || ""),
                    mainProducts: sanitizeInput(jsonData[5]?.[2] || ""),
                    differentiation: sanitizeInput(jsonData[6]?.[2] || ""),
                    corporatePhilosophy: sanitizeInput(jsonData[7]?.[2] || ""),
                    extraPrompt: sanitizeInput(jsonData[8]?.[2] || ""),
                    customerValue: sanitizeInput(jsonData[9]?.[2] || ""),
                    cost: sanitizeInput(jsonData[10]?.[2] || ""),
                    convenience: sanitizeInput(jsonData[11]?.[2] || ""),
                    informationChannel: sanitizeInput(jsonData[12]?.[2] || ""),
                    industryStandards: sanitizeInput(jsonData[13]?.[2] || ""),
                    trustFactors: sanitizeInput(jsonData[14]?.[2] || "")
                });

                alert("ヒアリングシートが正常に読み込まれました！");
            } catch (error) {
                alert("ファイルの読み込み中にエラーが発生しました。正しいフォーマットか確認してください。");
            }
        };
        reader.readAsArrayBuffer(file);
    };

    // ✅ データクリア処理
    const handleClearData = () => {
        setStrategyData({
            clientName: "",
            establishmentYear: "",
            businessDescription: "",
            mainProducts: "",
            customerValue: "",
            corporatePhilosophy: "",
            cost: "",
            convenience: "",
            informationChannel: "",
            differentiation: "",
            industryStandards: "",
            trustFactors: "",
            extraPrompt: ""
        });

         // 🔹 ファイル選択をリセット
         const fileInput = document.querySelector(".sheet-upload input[type='file']");
         if (fileInput) fileInput.value = "";

        // 🔹 ファイル選択リセット（input の key を変更することで再レンダリング）
        setFileInputKey(Date.now());

        alert("入力データをクリアしました！");
    };

    useEffect(() => {
        // **プロジェクトの詳細情報を取得**
        fetch("https://pmwqkcptnd.execute-api.ap-northeast-3.amazonaws.com/prod/api/list", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                action: "fetchProjectDetails",
                company_code: companyCode,
                project_id: projectId
            }),
        })
            .then(response => response.json())
            .then(data => {
                if (data.project) {
                    setProjectData(data.project);
                    setEditableProject({
                        project_name: data.project.project_name,
                        client_name: data.project.client_name,
                        status: data.project.status,
                        description: data.project.description
                    });
                } else {
                    alert("プロジェクト情報が取得できません。");
                }
            })
            .catch(error => console.error("❌ プロジェクト詳細取得エラー:", error))
            .finally(() => setLoading(false));
    }, [projectId, companyCode]);

    const handleInputChange = (field, value) => {
        setStrategyData(prev => {
            const updatedData = { ...prev, [field]: value };
            //console.log("📌 [DEBUG] handleInputChange - 更新後の strategyData:", updatedData);
            return updatedData;
        });
    };
        
    const handleStartStrategy = async () => {
        setStrategyResult(null);
        setStrategyLoading(true);
        setImageUrl(null); // 🔹 画像の状態をリセット
        setDocumentId(null);
        setContent(""); // 🔹 ドキュメント内容をリセット
    
        try {
            const response = await fetch("https://j4uljyd6pl.execute-api.ap-northeast-3.amazonaws.com/prod/api/strategy", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    action: "generate",
                    ...strategyData,
                    projectId
                }),
            });
    
            const data = await response.json();

            if (response.ok) {
                setStrategyResult(formatStrategyOutput(data.strategy));
                setImageUrl(data.imageUrl);
                 // 🔹 ドキュメント内容 にもセット
                 setContent(data.strategy);
            } else {
                alert(data.message || "SNS戦略の生成に失敗しました");
            }
        } catch (error) {
            alert("サーバーに接続できませんでした");
        } finally {
            setStrategyLoading(false);
        }
    };

    const handleSaveDocument = async () => {
        if (!content || selectedFormats.length === 0) {
            alert("ドキュメント名・内容を入力し、フォーマットを選択してください");
            return;
        }
    
        try {
            const response = await fetch("https://j4uljyd6pl.execute-api.ap-northeast-3.amazonaws.com/prod/api/strategy", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    action: "save-document",
                    projectId,
                    companyName,
                    documentName,
                    documentType:"SNS戦略計画書",
                    content,
                    formats: selectedFormats
                }),
            });
    
            const result = await response.json();
    
            if (response.ok) {
                alert(`ドキュメントが保存されました！`);
            } else {
                alert(result.message || "エラーが発生しました");
            }
        } catch (error) {
            alert("サーバーに接続できませんでした");
        }
    };

    const handleSaveSNSDocument = async (date) => {
        try {
            const response = await fetch("https://j4uljyd6pl.execute-api.ap-northeast-3.amazonaws.com/prod/api/strategy", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    action: "save-document",
                    projectId,
                    companyName,
                    documentName: `${date}-SNS投稿文書`, // 🔥 `date` を含めたフォーマットに修正
                    documentType: "SNS投稿文書",
                    content: posts,
                    formats: ["text"] // 🔥 変数 `TXT` ではなく文字列の "TXT" に修正
                }),                
            });
    
            const result = await response.json();
    
            if (response.ok) {
                alert(`ドキュメントが保存されました！`);
            } else {
                alert(result.message || "エラーが発生しました");
            }
        } catch (error) {
            alert("サーバーに接続できませんでした");
        }
    };

    /**
     * 🔹 OpenAI の出力を適切なフォーマットに変換する関数
     */
    const formatStrategyOutput = (strategy) => {
        return strategy
            .split("\n") // 🔹 改行ごとに分割
            .map((line, index) => {
                if (line.startsWith("### ")) {
                    return `<h3 key=${index}>${line.replace("### ", "")}</h3>`;
                } else if (line.startsWith("- **")) {
                    return `<li key=${index}><strong>${line.replace("- **", "").replace("**:", ":")}</strong></li>`;
                } else if (line.startsWith("- ")) {
                    return `<li key=${index}>${line.replace("- ", "")}</li>`;
                } else if (line.includes("**")) {
                    return `<p key=${index}>${line.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")}</p>`;
                } else if (line.trim() === "") {
                    return `<br key=${index} />`;
                } else {
                    return `<p key=${index}>${line}</p>`;
                }
            })
            .join("");
    };
    
    // フォーマット選択用チェックボックス
    const handleFormatChange = (format) => {
        setSelectedFormats(prev =>
            prev.includes(format)
                ? prev.filter(f => f !== format)  // すでに選択されているなら削除
                : [...prev, format]  // 追加
        );
    };

    const handleProjectSave = async () => {
        try {
            const response = await fetch("https://j4uljyd6pl.execute-api.ap-northeast-3.amazonaws.com/prod/api/strategy", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    action: "edit-project",
                    projectId,
                    projectName: editableProject.project_name,
                    clientName: editableProject.client_name,
                    status: parseFloat(editableProject.status),  // ✅ 数値に変換して送信
                    description: editableProject.description
                }),
            });
    
            const result = await response.json();
            if (response.ok) {
                alert("プロジェクト情報が更新されました！");
            } else {
                alert(result.message || "エラーが発生しました");
            }
        } catch (error) {
            console.error("❌ プロジェクト保存エラー:", error);
            alert("サーバーに接続できませんでした");
        }
    };

    const statusOptions = [
        { value: "1.0", label: "未着手" },
        { value: "3.0", label: "ヒアリング中" },
        { value: "5.0", label: "企画書作成中" },
        { value: "7.0", label: "運用準備中" },
        { value: "9.0", label: "運用中" }
    ];
    
    const handleSaveImage = async (saveImage) => {
        if (!saveImage) {
            alert("画像URLがありません");
            return;
        }
    
        try {
            // ✅ S3にアップロード＆データベース保存リクエスト
            const response = await fetch("https://j4uljyd6pl.execute-api.ap-northeast-3.amazonaws.com/prod/api/strategy", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    action: "save-image",
                    projectId,
                    companyCode,
                    companyName,
                    clientName,
                    imageUrl: saveImage,
                }),
            });
    
            if (!response.ok) throw new Error((await response.json()).message || "画像の保存に失敗しました");
    
            const { documentId } = await response.json();
            setDocumentId(documentId);
            alert(`画像が保存され、ドキュメントIDが発行されました: ${documentId}`);
    
            // ✅ 画像の取得 & ダウンロード処理
            await downloadImage(saveImage, "sns_strategy_image.png");
    
        } catch (error) {
            console.error("❌ 画像保存エラー:", error);
            alert(error.message || "サーバーに接続できませんでした");
        }
    };
    
    // ✅ 画像ダウンロードを関数化
    const downloadImage = async (imageUrl, filename) => {
        try {
            const imageResponse = await fetch(imageUrl);
            if (!imageResponse.ok) throw new Error("画像の取得に失敗しました");
    
            const imageBlob = await imageResponse.blob();
            const imageObjectUrl = URL.createObjectURL(imageBlob);
    
            const link = document.createElement("a");
            link.href = imageObjectUrl;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
    
            setTimeout(() => URL.revokeObjectURL(imageObjectUrl), 5000); // ✅ メモリ解放
        } catch (error) {
            console.error("❌ 画像ダウンロードエラー:", error);
            alert(error.message);
        }
    };
    
    // 🔹 テンプレートファイルのダウンロード
    const handleDownloadSheet = () => {
        const templatePath = `${process.env.PUBLIC_URL}/static/SNS-Strategy-Systemヒアリングシート.xlsx`;
        const link = document.createElement('a');
        link.href = templatePath;
        link.setAttribute('download', 'SNS-Strategy-Systemヒアリングシート.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const parseContent = (text) => {
        const result = {
            persona: "",
            appealPoints: "",
            expression: "",
            snsStrategyRaw: ""  // 🔥 SNS戦略は一旦文字列で保存
        };
    
        const lines = text.split("\n");
        let currentSection = null;
    
        lines.forEach(line => {
            line = line.trim(); // 🔥 空白をトリム
    
            // 📌 セクションを判定
            if (/ターゲットペルソナ|ターゲットインサイト/.test(line)) {
                currentSection = "persona";
            } else if (/訴求軸の比重/.test(line)) {
                currentSection = "appealPoints";
            } else if (/表現軸の提案/.test(line)) {
                currentSection = "expression";
            } else if (/SNS運用戦略/.test(line)) {
                currentSection = "snsStrategyRaw";
            } 
            // ✅ セクション名ではないが、現在のセクションが確定している場合は追加
            else if (currentSection) {
                result[currentSection] += line + "\n";
            }
        });
    
        // ✅ 各フィールドの不要な改行を整理
        Object.keys(result).forEach(key => {
            result[key] = result[key].trim(); // 余計な改行を削除
        });
        return result;
    };

    const handleStrategyUpdate = (updatedData) => {
        setStrategyData(prev => {
            const prevStrategy = prev.snsStrategy || {};
            const updatedStrategy = updatedData.snsStrategy || {};
    
            // 🔥 **変更がないならスキップ**
            if (JSON.stringify(prevStrategy) === JSON.stringify(updatedStrategy)) {
                //console.log("⚠️ `handleStrategyUpdate`: データ変更なし、更新をスキップ");
                return prev;
            }
    
            //console.log("📌 [DEBUG] `handleStrategyUpdate` 更新:", updatedData);
            return {
                ...prev,
                snsStrategy: { ...updatedStrategy }
            };
        });
    };

    const handleGenerateSNSPosts = async () => {
        try {
            setLoadingSNS(true);
    
            if (!date || !theme) {
                alert("投稿予定日と今回のテーマは必須です");
                return;
            }
    
            // ✅ `document.querySelectorAll` でチェックされたSNSを取得
            const checkedSNS = Array.from(document.querySelectorAll(".sns-strategy-item input[type='checkbox']:checked"))
                .map(input => input.value);
    
            // ✅ `document.querySelectorAll` で対応するテキストエリアの値を取得
            const content = Object.fromEntries(
                checkedSNS.map(sns => {
                    const textarea = document.querySelector(`.sns-strategy-item textarea[name="${sns}"]`);
                    return [sns, textarea ? textarea.value.trim() : ""];
                })
            );
    
            if (checkedSNS.length === 0) {
                alert("少なくとも1つのSNSを選択してください");
                return;
            }
    
            if (Object.values(content).every(text => text === "")) {
                alert("SNS戦略が空です。投稿内容を入力してください");
                return;
            }
    
            // ✅ 追加要望を取得
            const extraPrompt = strategyData.additionalRequests?.trim() || "";
            //console.log("📌 [DEBUG] 送信前の `extraPrompt`:", extraPrompt);
    
            // ✅ 送信データを `//console.log()` でチェック
            const requestData = {
                action: "generate-sns-posts",
                companyName: companyName || "未設定",
                projectId,
                platforms: checkedSNS,
                content: content,
                persona: parsedData.persona,
                appealPoints: parsedData.appealPoints,
                expression: parsedData.expression,
                date,
                theme,
                extraPrompt: extraPrompt,  // ✅ ここで追加要望を送る
            };
    
            //console.log("📌 [DEBUG] 実際に送信するデータ:", JSON.stringify(requestData, null, 2));
    
            const response = await fetch("https://hmt7kejebi.execute-api.ap-northeast-3.amazonaws.com/prod/api/sns-production", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            });
    
            const data = await response.json();
    
            if (response.ok) {
                setPosts(data.posts);
    
                try {
                    setSNSImageUrl(prev => {
                        if (typeof data.SNSimageUrl === "string" && data.SNSimageUrl.startsWith("http")) {
                            return data.SNSimageUrl;
                        } else if (typeof data.SNSimageUrl === "object" && data.SNSimageUrl.imageUrl) {
                            return data.SNSimageUrl.imageUrl;
                        } else {
                            return prev;
                        }
                    });
                } catch (error) {
                    console.error("📌 [ERROR] setSNSImageUrl の処理でエラー:", error);
                }
            }
        } catch (error) {
            console.error("❌ [ERROR] 投稿生成エラー:", error);
            alert("サーバーに接続できませんでした");
        } finally {
            setLoadingSNS(false);
        }
    };
    

    const formatPostText = (text) => {
        return text
            .replace(/### (.*?)\n/g, '<h5>$1</h5>') // "### " で始まる部分を見出し（h4）に変換
            .replace(/\n/g, '<br>') // 改行を <br> に変換
            .replace(/(https?:\/\/[^\s]+)/g, '<a href="$1" target="_blank">$1</a>') // URLをリンク化
            .replace(/(\d+\.\s#[^\s]+)/g, '<span class="hashtag">$1</span>'); // ハッシュタグを装飾
    };

    useEffect(() => {
        if (!loadedContent || typeof loadedContent !== "string" || loadedContent.trim() === "") {
            console.warn("⚠️ `loadedContent` が無効なので処理をスキップ");
            return;
        }
    
        const parsedStrategy = parseSNSStrategy(loadedContent);
    
        if (!parsedStrategy || Object.keys(parsedStrategy).length === 0) {
            console.warn("⚠️ `parsedStrategy` が無効なため `snsStrategy` を更新しません");
            return;
        }
    
        setParsedData(prev => ({
            ...prev,
        }));
    
        //console.log("📌 [DEBUG] `setParsedData` 適用後:", JSON.stringify(parsedStrategy, null, 2));
    
    }, [loadedContent]);    

    // 🔹 カスタム画像のアップロード
    const handleUploadImages = async (event) => {
        const files = event.target.files;
        if (!files.length) return;
    
        const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp"]; // ✅ 許可する画像フォーマット
        const uploadedImageList = [];
    
        setUploading(true);
    
        for (let file of files) {
            if (!allowedTypes.includes(file.type)) {
                alert(`${file.name} は画像ファイルではありません。PNG, JPG, JPEG, WEBP のみアップロード可能です。`);
                continue;
            }
    
            try {
                // 🔹 署名付きURLを取得
                const presignedResponse = await axios.post("https://your-api-endpoint.com/get-upload-url", {
                    fileName: file.name,
                    fileType: file.type
                });
    
                const { uploadUrl, fileUrl } = presignedResponse.data;
    
                // 🔹 S3にアップロード
                await axios.put(uploadUrl, file, {
                    headers: { "Content-Type": file.type }
                });
    
                uploadedImageList.push({ name: file.name, url: fileUrl });
    
            } catch (error) {
                console.error("画像アップロードエラー:", error);
                alert("画像のアップロードに失敗しました");
            }
        }
    
        setUploadedImages((prev) => [...prev, ...uploadedImageList]);
        setUploading(false);
    };
    

    const handleGenerateLP = async () => {
        setLoadingLP(true);
        setLpHtml("");
        setProgress(0);
        setLpStatus("LP生成開始...");
    
        // ✅ 進捗取得を開始（LP生成開始と同時に進捗チェック）
        const interval = setInterval(async () => {
            try {
                const progressResponse = await axios.post(
                    "https://e97xv17f10.execute-api.ap-northeast-3.amazonaws.com/prod/api/LP",
                    { action: "progress", projectId }
                );

                setProgress(progressResponse.data.progress);
                setLpStatus(progressResponse.data.status);
    
                if (progressResponse.data.progress >= 100) {
                    clearInterval(interval);
                    setProgress(0);  // 🔹 プログレスバーをリセット
                    setLoadingLP(false);
                }
            } catch (error) {
                console.error("❌ 進捗取得エラー:", error);
                clearInterval(interval);
                setProgress(0);  // 🔹 エラー時もプログレスバーを削除
                setLoadingLP(false);
            }
        }, 10000); // ✅ 10秒ごとに進捗を取得
    
        try {
            // 🔹 LP生成リクエストを送信（`await` でブロックしない）
            const response = await axios.post("https://e97xv17f10.execute-api.ap-northeast-3.amazonaws.com/prod/api/LP", {
                action: "generate-lp",
                companyName,
                clientName: strategyData.clientName || editableProject.client_name,
                projectId,
                persona: parsedData.persona,
                appealPoints: parsedData.appealPoints,
                expression: parsedData.expression,
                addRequestsLP: strategyData.addRequestsLP,
                customImages: uploadedImages
            });
    
            const data = response.data;
    
            if (response.status === 200) {
                if (data.lpHtml) {
                    setLpHtml(data.lpHtml);
                    setProgress(0);  // 🔹 LP生成成功時もプログレスバーを削除
                } else {
                    console.error("❌ `lpHtml` が `null` です: ", data);
                    alert("LPの生成は成功しましたが、HTMLデータが返ってきませんでした");
                    setProgress(0);  // 🔹 エラー時もプログレスバーを削除
                }
            } else {
                alert("LPの生成に失敗しました");
                setProgress(0);  // 🔹 エラー時もプログレスバーを削除
            }
        } catch (error) {
            console.error("LP生成エラー:", error);
            alert("サーバーに接続できませんでした");
            clearInterval(interval); // ✅ エラー時も `setInterval` を停止
            setProgress(0);  // 🔹 エラー時もプログレスバーを削除
            setLoadingLP(false);
        }
    };    
    
    const handleDownloadLP = async () => {
        if (!lpHtml) return;
        const uniqueId = lpHtml.match(/\/tmp\/([^/]+)\//)?.[1];  // URLからユニークIDを抽出
        setSavingLP(true);
        try {
            const response = await fetch("https://e97xv17f10.execute-api.ap-northeast-3.amazonaws.com/prod/api/LP", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    action: "download-lp",
                    companyName,
                    projectId,
                    uniqueId: uniqueId,
                    lpHtml
                }),
            });
    
            if (!response.ok) {
                throw new Error("サーバーからエラー応答");
            }
    
            const result = await response.json();
            const { documentId, zippedUrl } = result;
    
            if (!documentId || !zippedUrl) {
                throw new Error("ドキュメントIDまたはダウンロードURLが取得できませんでした");
            }
    
            // ここでまずアラート表示
            alert(`zipファイルを保存しました：ドキュメントID：${documentId}`);
    
            // その後自動ダウンロード開始
            const link = document.createElement("a");
            link.href = zippedUrl;  // ← 直接S3の署名付きURLを使う
            link.setAttribute("download", "landing_page.zip");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
    
        } catch (error) {
            console.error("LPダウンロードエラー:", error);
            alert("LPのダウンロードに失敗しました");
        } finally {
            setSavingLP(false);
        }
    };    
    
    if (loading) return <p>プロジェクト情報を読み込み中...</p>;

    return (
        <div className="container">
            <h1 className="title">SNS Strategy Dashboard</h1>
            <div className="project-info">
                <h2>プロジェクト情報</h2>
                {projectData ? (
                    <>
                        <label>プロジェクト名</label>
                        <input type="text" className="input" value={editableProject.project_name} onChange={(e) => setEditableProject({ ...editableProject, project_name: sanitizeInput(e.target.value) })} />

                        <label>クライアント名</label>
                        <input type="text" className="input" value={editableProject.client_name} onChange={(e) => setEditableProject({ ...editableProject, client_name: sanitizeInput(e.target.value) })} />

                        <label>進捗状況</label>
                        <select 
                            className="input"
                            value={editableProject.status}
                            onChange={(e) => setEditableProject({ ...editableProject, status: sanitizeInput(e.target.value) })}
                        >
                            {statusOptions.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>

                        <label>プロジェクト説明</label>
                        <textarea className="input" value={editableProject.description} onChange={(e) => setEditableProject({ ...editableProject, description: sanitizeInput(e.target.value) })}></textarea>

                        <button className="common-button" onClick={handleProjectSave}>更新</button>
                    </>
                ) : <p>プロジェクト情報が取得できません。</p>}
            </div>

            {/* Google Chrome風タブメニュー */}
            <div className="tab-container">
                <div className="tab-menu">
                    {["運用策定", "SNS投稿文書作成", "LP案作成"].map((tab) => (
                        <div
                            key={tab}
                            className={`tab-item ${activeTab === tab ? "active" : ""}`}
                            onClick={() => setActiveTab(tab)}
                        >
                            {tab}
                        </div>
                    ))}
                </div>
            </div>

             {/* タブごとのコンテンツ */}
            <div className="tab-content">
                {activeTab === "運用策定" && (
                    <div>
                        <div className="form-container">
                            <h2 className="section-title">運用策定</h2>
                            <h3>ヒアリングシートのアップロード</h3>
                            <div className="sheet-container">
                                <button className="hearing-sheet-download-button" onClick={handleDownloadSheet}>
                                    テンプレートダウンロード
                                </button>
                                <input className="sheet-upload" type="file" accept=".xlsx, .xls" onChange={handleFileUpload} />
                                <button className="clear-button" onClick={handleClearData}>データクリア</button>
                            </div>
                            <div className="form-grid">  {/* ✅ 3カラムレイアウト */}
                                {/* 🔹 企業情報 */}
                                <div className="form-column">
                                    <h3 className="sub-section-title">企業情報</h3>

                                    <label className="label">会社名(※必須)</label>
                                    <input 
                                        type="text" 
                                        className="input" 
                                        value={strategyData.clientName} 
                                        onChange={(e) => handleInputChange("clientName", e.target.value)} 
                                        placeholder="例: 株式会社AYATORI" 
                                        required
                                    />

                                    <label className="label">設立年</label>
                                    <input 
                                        type="text" 
                                        className="input" 
                                        value={strategyData.establishmentYear} 
                                        onChange={(e) => handleInputChange("establishmentYear", e.target.value)} 
                                        placeholder="例: 2018" 
                                    />

                                    <label className="label">事業内容(※必須)</label>
                                    <textarea 
                                        className="input" 
                                        value={strategyData.businessDescription} 
                                        onChange={(e) => handleInputChange("businessDescription", e.target.value)} 
                                        placeholder="例: Web制作とSNSマーケティングを提供"
                                        required
                                    ></textarea>

                                    <label className="label">主要商品・サービス</label>
                                    <input 
                                        type="text" 
                                        className="input" 
                                        value={strategyData.mainProducts} 
                                        onChange={(e) => handleInputChange("mainProducts", e.target.value)} 
                                        placeholder="例: SNS広告運用、Webサイト制作" 
                                    />

                                    <label className="label">企業理念・ミッション</label>
                                    <textarea 
                                        className="input" 
                                        value={strategyData.corporatePhilosophy} 
                                        onChange={(e) => handleInputChange("corporatePhilosophy", e.target.value)} 
                                        placeholder="例: 私たちはテクノロジーの力で中小企業のデジタル変革を支援します。"
                                    ></textarea>   
                                </div>

                                {/* 🔹 4C分析 */}
                                <div className="form-column">
                                    <h3 className="sub-section-title">4C分析</h3>
                                    <label className="label">顧客価値</label>
                                    <textarea className="input" value={strategyData.customerValue} onChange={(e) => handleInputChange("customerValue", e.target.value)} placeholder="例: ROIの向上、ブランド認知度向上"></textarea>

                                    <label className="label">コスト</label>
                                    <textarea className="input" value={strategyData.cost} onChange={(e) => handleInputChange("cost", e.target.value)} placeholder="例: 低コストで高ROIを実現"></textarea>

                                    <label className="label">利便性</label>
                                    <textarea className="input" value={strategyData.convenience} onChange={(e) => handleInputChange("convenience", e.target.value)} placeholder="例: ワンストップでSNS運用が可能"></textarea>

                                    <label className="label">情報発信手段</label>
                                    <textarea className="input" value={strategyData.informationChannel} onChange={(e) => handleInputChange("informationChannel", e.target.value)} placeholder="例: SNS広告、ブログ、YouTube"></textarea>
                                </div>

                                {/* 🔹 3P分析 */}
                                <div className="form-column">
                                    <h3 className="sub-section-title">3P分析</h3>
                                    <label className="label">差別化ポイント(※必須)</label>
                                    <textarea className="input" value={strategyData.differentiation} onChange={(e) => handleInputChange("differentiation", e.target.value)} placeholder="例: AIを活用したマーケティング最適化" required></textarea>

                                    <label className="label">業界内の共通項</label>
                                    <textarea className="input" value={strategyData.industryStandards} onChange={(e) => handleInputChange("industryStandards", e.target.value)} placeholder="例: 広告運用の透明性、KPI管理"></textarea>

                                    <label className="label">顧客への信頼要素</label>
                                    <textarea className="input" value={strategyData.trustFactors} onChange={(e) => handleInputChange("trustFactors", e.target.value)} placeholder="例: 実績公開、クライアントの声"></textarea>
                                </div>
                            </div>
                        </div>

                        {strategyResult && (
                            <div className="result-container1">
                                <h2 className="result-title">策定結果</h2>
                                {imageUrl && (
                                    <div className="image-container">
                                        <h3 className="image-title">イメージボード</h3>
                                        <img src={imageUrl} alt="SNS戦略のイメージ" className="strategy-image" />
                                        <button
                                            className="common-button" 
                                            onClick={() => handleSaveImage(imageUrl)} 
                                            disabled={!imageUrl} // 画像URLがないときはボタンを無効化
                                            >
                                            画像を保存
                                        </button>

                                        {documentId && (
                                            <p className="document-id-text">📂 保存されたドキュメントID: <strong>{documentId}</strong></p>
                                        )}
                                    </div>
                                )}
                                <p>{strategyResult.summary}</p>
                                <div dangerouslySetInnerHTML={{ __html: strategyResult }} />
                            </div>    
                        )}

                        <div className="button-container">
                            <label className="label"><strong>追加要望（任意）</strong></label>
                            <textarea
                                className="ex-prompt" 
                                value={strategyData.extraPrompt} 
                                onChange={(e) => handleInputChange("extraPrompt", e.target.value)} 
                                placeholder="例: もっと若年層向けの施策を増やしてほしい"
                            ></textarea>
                            <button 
                                className="common-button" 
                                onClick={handleStartStrategy} 
                                disabled={strategyloading}
                            >
                                {strategyloading ? "AI思考中..." : "SNS戦略策定"}
                            </button>
                        </div>

                        {strategyResult && (
                            <>
                                <hr />
                                <div className="result-container2">
                                    <label className="label"><strong>ドキュメント名</strong></label>
                                    <input 
                                        type="text" 
                                        className="input" 
                                        value={documentName} 
                                        onChange={(e) => setDocumentName(sanitizeInput(e.target.value))} 
                                        placeholder="例: SNS戦略計画書" 
                                    />

                                    <label className="label"><strong>書類種別</strong></label>
                                    <input 
                                        type="text" 
                                        className="input" 
                                        value="SNS戦略計画書"
                                        disabled
                                    />

                                    <label className="label"><strong>ドキュメント内容</strong></label>
                                    <textarea
                                        className="strategy-document" 
                                        value={content} 
                                        onChange={(e) => setContent(sanitizeInput(e.target.value))} 
                                        placeholder="SNS戦略の概要..."
                                    ></textarea>

                                    <label className="label"><strong>保存形式を選択（複数可）</strong></label>
                                    <div className="checkbox-group">
                                        {['word', 'excel', 'pdf', 'text'].map((format) => (
                                            <label key={format} className="checkbox-label">
                                                <input 
                                                    type="checkbox" 
                                                    checked={selectedFormats.includes(format)} 
                                                    onChange={() => handleFormatChange(format)} 
                                                />
                                                {format.toUpperCase()}
                                            </label>
                                        ))}
                                    </div>

                                    <button className="common-button" onClick={handleSaveDocument}>保存</button>
                                </div>
                            </>
                        )}
                    </div>
                )}
                {activeTab === "SNS投稿文書作成" && (
                    <div>
                        <h2 className="section-title">SNS投稿文書作成</h2>
                        <div className="sns-post-generator">
                            <button className="load-strategy-button" onClick={fetchFiles}>
                                📂 SNS運用戦略書を読み込む
                            </button>

                            {isSnsFileListLoaded && (
                                <>
                                    <label>📂 SNS戦略計画書の選択:</label>
                                    <select className="choice-strategy" value={snsSelectedFile} onChange={(e) => handleFileSelect(e.target.value)}>
                                        <option value="">使用するドキュメントを選択してください</option>
                                        {snsStrategyFiles.map(file => (
                                            <option key={file.id} value={file.id}>
                                                {file.fileName} ({file.fileType})
                                            </option>
                                        ))}
                                    </select>
                                </>
                            )}  
                            
                            <label>SNS運用戦略書:</label>
                            <textarea value={loadedContent || content || ""} onChange={(e) => setContent(e.target.value)} rows={10} />

                            <h3>🔹 自動解析結果</h3>

                            <label>🎯 ターゲットペルソナ:</label>
                            <textarea value={parsedData.persona} onChange={(e) => setParsedData({ ...parsedData, persona: e.target.value })} />

                            <label>✨ 訴求ポイント:</label>
                            <textarea value={parsedData.appealPoints} onChange={(e) => setParsedData({ ...parsedData, appealPoints: e.target.value })} />

                            <label>🎨 表現軸:</label>
                            <textarea value={parsedData.expression} onChange={(e) => setParsedData({ ...parsedData, expression: e.target.value })} />

                            <SNSParserComponent loadedContent={loadedContent} onStrategyUpdate={handleStrategyUpdate} />;

                            <div className="theme-date-container">
                                <div>
                                    <label>📅 投稿予定日【必須】:</label>
                                    <input type="date" value={date} onChange={(e) => setDate(e.target.value)} required/>
                                </div>
                                <div>
                                    <label>📌 今回のテーマ【必須】:</label>
                                    <input type="text" value={theme} onChange={(e) => setTheme(e.target.value)} placeholder="例: AIマーケティングの未来" required/>
                                </div>
                            </div>

                            <h4>追加要望（任意）</h4>
                            <textarea
                                className="add-requests" 
                                value={strategyData.additionalRequests} 
                                onChange={(e) => handleInputChange("additionalRequests", e.target.value)} 
                                placeholder="例: もっと若年層向けの施策を増やしてほしい"
                            ></textarea>

                            {posts && (
                                <div className="sns-generated-content">
                                    <h3>🔹 生成されたSNS投稿</h3>

                                    {/* 画像を表示 */}
                                    {SNSimageUrl && (
                                        <div>     
                                            <img src={SNSimageUrl} alt="生成画像" className="sns-image" />
                                        </div>
                                    )}
                                    <button
                                        className="common-button"
                                        onClick={() => handleSaveImage(SNSimageUrl)} 
                                        disabled={!SNSimageUrl} // 画像URLがないときはボタンを無効化
                                        >
                                        画像を保存
                                    </button>
                                    <hr />
                                    {/* 各SNS投稿を表示 */}
                                    {Object.entries(posts).map(([platform, text]) => (
                                        <div key={platform} className="sns-post">
                                            <h4>{platform} 投稿</h4>
                                            <div className="sns-text" dangerouslySetInnerHTML={{ __html: formatPostText(text) }} />
                                        </div>
                                    ))}
                                    <button className="common-button" onClick={() => handleSaveSNSDocument(date)}>文書を保存</button>
                                </div>
                            )}

                            <button 
                                className='generate-sns' 
                                onClick={handleGenerateSNSPosts} 
                                disabled={loadingSNS}
                            >
                                {loadingSNS ? "生成中..." : "投稿を生成"}
                            </button>
                        </div>
                    </div>
                )}
                {activeTab === "LP案作成" && (
                    <div>
                        <h2 className="section-title">LP案作成</h2>
                        <div className="LP-generator">
                            <button className="load-strategy-button" onClick={fetchLPFiles}>
                                📂 運用戦略書を読み込む
                            </button>

                            {isLPFileListLoaded && (
                                <>
                                    <label>📂 戦略計画書の選択:</label>
                                    <select className="choice-strategy" value={LPSelectedFile} onChange={(e) => handleFileSelect(e.target.value)}>
                                        <option value="">使用するドキュメントを選択してください</option>
                                        {LPStrategyFiles.map(file => (
                                            <option key={file.id} value={file.id}>
                                                {file.fileName} ({file.fileType})
                                            </option>
                                        ))}
                                    </select>
                                </>
                            )}

                            <label>運用戦略書:</label>
                            <textarea value={loadedContent || content || ""} onChange={(e) => setContent(e.target.value)} rows={10} />

                            <h3>🔹 自動解析結果</h3>
                            <label>🎯 ターゲットペルソナ:</label>
                            <textarea value={parsedData.persona} />

                            <label>✨ 訴求ポイント:</label>
                            <textarea value={parsedData.appealPoints} />

                            <label>🎨 表現軸:</label>
                            <textarea value={parsedData.expression} />

                            <h4>追加要望（任意）</h4>
                            <textarea
                                className="add-requests" 
                                value={strategyData.addRequestsLP} 
                                onChange={(e) => handleInputChange("addRequestsLP", e.target.value)} 
                                placeholder="例: もっと若年層向けの施策を増やしてほしい"
                            ></textarea>

                            <h4>カスタム画像アップロード（任意）</h4>
                            <input type="file" accept="image/png, image/jpeg, image/jpg, image/webp" multiple onChange={handleUploadImages} />

                            {uploading && <p>アップロード中...</p>}

                                <h4>アップロード済み画像</h4>
                                <ul>
                                    {uploadedImages.map((img, index) => (
                                        <li key={index}>
                                            <img src={img.url} alt={img.name} width={100} />
                                            {img.name}
                                        </li>
                                    ))}
                                </ul>

                                <button 
                                    className="generate-lp-button"
                                    onClick={handleGenerateLP} 
                                    disabled={loadingLP}
                                >
                                    {loadingLP ? lpStatus : "LPを生成"}
                                </button>

                                {/* ✅ 進捗バーはボタンの外に置く */}
                                {loadingLP && <ProgressBar progress={progress} />}        
                        </div>

                        <div className="LP-content">
                            {lpHtml && (
                                <div>
                                    <h3>🔹 LPプレビュー</h3>
                                    <LPPreview lpUrl={lpHtml} /> {/* ✅ 修正したLPプレビューを使用 */}
                                    <div className="LP-button">
                                        <button className="download-lp-button" onClick={() => window.open(lpHtml, "_blank")}>
                                            LPを新しいタブで開く
                                        </button>

                                        <button className="download-lp-button" onClick={handleDownloadLP} disabled={savingLP}>
                                            {savingLP ? "LP保存中" : "LPファイルを保存＆ダウンロード"}
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
            <div className="navigate-button">
                <button type="button" className="back-button" onClick={() => navigate(`/document-page`, { state: { companyName, personalName, projectId } })}>
                    資料一覧へ
                </button>
                <button type="button" className="back-button" onClick={() => navigate('/portal')}>
                    ポータルへ戻る
                </button>
            </div>
        </div>        
    );
};

export default SnsStrategyPage;
